import type { AxiosRequestConfig, AxiosResponse, AxiosInstance } from 'axios';

export function typedGet<T>(
  axiosInstance: AxiosInstance,
  url: string,
  params?: unknown,
  config?: AxiosRequestConfig,
): Promise<T> {
  return axiosInstance
    .get<T>(url, { ...(config ?? {}), params: params ?? {} })
    .then((res: AxiosResponse<T>) => res.data);
}

export function typedPost<T>(
  axiosInstance: AxiosInstance,
  url: string,
  data?: unknown,
  config?: AxiosRequestConfig,
): Promise<T> {
  return axiosInstance
    .post<T>(url, data, config)
    .then((res: AxiosResponse<T>) => res.data);
}

export function typedPut<T>(
  axiosInstance: AxiosInstance,
  url: string,
  data?: unknown,
  config?: AxiosRequestConfig,
): Promise<T> {
  return axiosInstance
    .put<T>(url, data, config)
    .then((res: AxiosResponse<T>) => res.data);
}

export function typedDelete<T>(
  axiosInstance: AxiosInstance,
  url: string,
  params?: unknown,
  config?: AxiosRequestConfig,
): Promise<T> {
  return axiosInstance
    .delete<T>(url, { ...(config ?? {}), params: params ?? {} })
    .then((res: AxiosResponse<T>) => res.data);
}
